import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

class DashboardGridBox extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        'static': PropTypes.bool
    };

    constructor(props, context) {
        super(props, context);
        this.gridRef = React.createRef(null);
        this.state = {};
    }

    componentDidMount() {
        this.mounted = true;

        this.readSize();
        // this.forceUpdate();
        //
        // window.addEventListener('resize', () => {
        //     this.readSize();
        //     this.forceUpdate();
        // });
    }

    componentDidUpdate() {
        this.readSize();
    }

    getStyleProperties(el, properties) {
        const result = {};

        if (global.getComputedStyle) {
            const style = global.getComputedStyle(el, null);

            properties.forEach((prop) => {
                result[prop] = style.getPropertyValue(prop);
            });
        } else {
            properties.forEach((prop) => {
                result[prop] = el.currentStyle[prop];
            });
        }

        return result;
    }

    readSize() {
        if (this.mounted) {
            
            const properties = this.getStyleProperties(el, [
                    'padding-left',
                    'padding-top',
                    'padding-right',
                    'padding-bottom'
                ]);

            const paddingLeft = parseInt(properties['padding-left'], 10);
            const paddingTop = parseInt(properties['padding-top'], 10);

            this.boxWidth = this.gridRef.current?.offsetWidth ?? 0;
            this.boxHeight = this.gridRef.current?.offsetHeight ?? 0;

            this.boxInnerWidth = this.boxWidth - paddingLeft - parseInt(properties['padding-right'], 10);
            this.boxInnerHeight = this.boxHeight - paddingTop - parseInt(properties['padding-bottom'], 10);
        }
    }

    render() {
        let title = '',
            className = this.props.className || '';

        className += ' grid-box';

        if (this.props.static) {
            className += ' static';
        }

        if (this.title) {
            title = <h3>{ this.title }</h3>;
        }

        return (
            <div className={className} {...this.props} ref={this.gridRef}>
                { title }
                { this.renderElement() }
            </div>
        );
    }
}

export default DashboardGridBox;
